import React from "react";
import './skill.css';
import SkillItem from "./skill_item";
import html  from './html.png';
import css from './css.png';
import js from './js.png';
import react from './react.png';
import nodejs from './nodejs.png';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const Skills = () =>{
  useEffect(()=>{
    Aos.init({
      duration: 2000,
       
     });
   },[]);
    return(
        <div className="skill" data-aos= 'fade-right' id="skill">
         <h3>My SkillSet</h3>
         <div className="skill__icon">
           <SkillItem img= {html} />
           <SkillItem img= {css} />
           <SkillItem img= {js} />
           <SkillItem img= {react} />
           <SkillItem img= {nodejs} />
         </div>
        </div>
    );
}

export default Skills